export enum InventoryType {
  CSA = 1,
  UL = 2,
  BOTH = 3,
}
